export const REGISTER_NOTIFICATION_ADD_PHONE_NUMBER_SUCCESS = "REGISTER_NOTIFICATION_ADD_PHONE_NUMBER_SUCCESS"
export const REGISTER_NOTIFICATION_ADD_PHONE_NUMBER_FAILED = "REGISTER_NOTIFICATION_ADD_PHONE_NUMBER_FAILED"
export const UPDATE_NOTIFICATION_EVENTS_PHONE_NUMBER_SUCCESS = "UPDATE_NOTIFICATION_EVENTS_PHONE_NUMBER_SUCCESS"
export const UPDATE_NOTIFICATION_EVENTS_PHONE_NUMBER_FAILED = "UPDATE_NOTIFICATION_EVENTS_PHONE_NUMBER_FAILED"
